export default __webpack_public_path__ + "static/media/bg-top-left.62c2b613.svg";